import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Location, CreateLocationDto } from 'types';

export const createLocation = (data: CreateLocationDto): Promise<Location> => {
  return axios.post('/api/locations', data);
};

type UseCreateLocationOptions = {
  config?: MutationConfig<typeof createLocation>;
};

export const useCreateLocation = ({ config }: UseCreateLocationOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createLocation,
  });
};
